// 增
export function setItem(key, val) {
  window.localStorage.setItem(key, val)
}
// 删
export function deleteItem(key) {
  window.localStorage.removeItem(key)
}
// 改
export function updateItem(key, val) {
  window.localStorage.setItem(key, val)
}
// 查
export function queryItem(key) {
  return window.localStorage.getItem(key)
}
// 清空
export function clear() {
  window.localStorage.clear()
}



// WEBPACK FOOTER //
// ./src/common/storage/Storage.js